import Vue from 'vue'
import Router from 'vue-router'
import {
	vxStore
} from "../store/vuex_store"

//Naij imports
const Nigeria = () => import('../components/nigeria/NigeriaHome.vue')
const NaijBusiness = () => import('../components/nigeria/business/NaijBusiness.vue')
const NaijHealth = () => import('../components/nigeria/NaijHealth.vue')
const NaijTech = () => import('../components/nigeria/NaijTech.vue')
const NaijScience = () => import('../components/nigeria/NaijScience.vue')
const NaijEntertainment = () => import('../components/nigeria/NaijEntertainment.vue')
const NaijSports = () => import('../components/nigeria/sports/NaijSports.vue')
const NaijFeatured = () => import('../components/nigeria/NaijFeatured.vue')
const NaijWorld = () => import('../components/nigeria/NaijWorld.vue')
const NaijAfrica = () => import('../components/nigeria/NaijAfrica.vue')
const About = () => import('../components/About.vue')
const ReachOut = () => import('../components/reach-out/ReachOut.vue')
const Discover = () => import('../components/discover/Discover.vue')

//World imports
const WorldBusiness = () => import('../components/world/WorldBusiness.vue')
const WorldEntertainment = () => import('../components/world/WorldEntertainment.vue')
const WorldHealth = () => import('../components/world/WorldHealth.vue')
const WorldScience = () => import('../components/world/WorldScience.vue')
const WorldSports = () => import('../components/world/WorldSports.vue')
const WorldTechnology = () => import('../components/world/WorldTech.vue')
const WorldFeatured = () => import('../components/world/WorldFeatured.vue')
const AroundTheWorldHome = () => import('../components/news/aroundTheWorld/AroundTheWorldHome.vue')

//Africa imports
const AfricaBusiness = () => import('../components/africa/AfricaBusiness.vue')
const AfricaEntertainment = () => import('../components/africa/AfricaEntertainment.vue')
const AfricaHealth = () => import('../components/africa/AfricaHealth.vue')
const AfricaScience = () => import('../components/africa/AfricaScience.vue')
const AfricaSports = () => import('../components/africa/AfricaSports.vue')
const AfricaTechnology = () => import('../components/africa/AfricaTech.vue')
const AfricaFeatured = () => import('../components/africa/AfricaFeatured.vue')

//Authentication imports
const Profile = () => import('../components/users/profile/Dashboard.vue')
const Auth = () => import('../components/users/authenticate/Auth.vue')

//Topics imports
const Agriculture = () => import('../components/news/topics/agriculture/AgricultureHome.vue')
const Art = () => import('../components/news/topics/art/ArtHome.vue')
const Cuisine = () => import('../components/news/topics/cuisine/CuisineHome.vue')
const Culture = () => import('../components/news/topics/culture/CultureHome.vue')
const Economy = () => import('../components/news/topics/economy/EconomyHome.vue')
const Education = () => import('../components/news/topics/education/EducationHome.vue')
const Environment = () => import('../components/news/topics/environment/EnvironmentHome.vue')
const Family = () => import('../components/news/topics/family/FamilyHome.vue')
const Fitness = () => import('../components/news/topics/fitness/FitnessHome.vue')
const Politics = () => import('../components/news/topics/politics/PoliticsHome.vue')
const Feminism = () => import('../components/news/topics/feminism/FeminismHome.vue')
const Election = () => import('../components/news/topics/election/ElectionHome.vue')
const CoronaVirus = () => import('../components/news/topics/coronaVirus/CoronaVirusHome.vue')
const BokoHaram = () => import('../components/news/topics/bokoHaram/BokoHaramHome.vue')
const Corruption = () => import('../components/news/topics/corruption/CorruptionHome.vue')

//Person/User imports
const Person = () => import('../components/news/Person.vue')
const UserView = () => import('../components/users/userView/UserView.vue')

//Story imports
const Story = () => import('../components/story/Story.vue')
const Source = () => import('../components/sources/Sources.vue')

const PageNotFound = () => import('../components/errors/404.vue')

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
			path: '/',
			components: {
				default: Nigeria
			},
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'NG')
				next()
			}
		},
		{
			path: '/reach-out',
			components: {
				default: ReachOut
			},
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', '')
				next()
			}
		},
		{
			name: 'about',
			path: '/about',
			components: {
				default: About
			},
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', '')
				next()
			}
		},
		{
			path: '/business',
			component: NaijBusiness,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Business')
				next()
			}
		},
		{
			path: '/health',
			component: NaijHealth,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Health')
				next()
			}
		},
		{
			path: '/technology',
			component: NaijTech,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Technology')
				next()
			}
		},
		{
			path: '/science',
			component: NaijScience,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Science')
				next()
			}
		},
		{
			path: '/entertainment',
			component: NaijEntertainment,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Entertainment')
				next()
			}
		},
		{
			path: '/sports',
			component: NaijSports,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Sports')
				next()
			}
		},
		{
			path: '/featured',
			component: NaijFeatured,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Featured')
				next()
			}
		},
		{
			path: '/around-the-world',
			component: AroundTheWorldHome,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'World')
				next()
			}
		},
		{
			path: '/discover',
			component: Discover,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Discover')
				next()
			}
		},
		{
			path: '/world',
			component: NaijWorld,
			children: [{
					path: '/world/featured',
					component: WorldFeatured
				},
				{
					path: '/world/business',
					component: WorldBusiness
				},
				{
					path: '/world/health',
					component: WorldHealth
				},
				{
					path: '/world/sports',
					component: WorldSports
				},
				{
					path: '/world/entertainment',
					component: WorldEntertainment
				},
				{
					path: '/world/science',
					component: WorldScience
				},
				{
					path: '/world/technology',
					component: WorldTechnology
				}
			],
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', '')
				next()
			}
		},
		{
			path: '/africa',
			component: NaijAfrica,
			children: [{
					path: '/africa/featured',
					component: AfricaFeatured
				},
				{
					path: '/africa/business',
					component: AfricaBusiness
				},
				{
					path: '/africa/health',
					component: AfricaHealth
				},
				{
					path: '/africa/sports',
					component: AfricaSports
				},
				{
					path: '/africa/entertainment',
					component: AfricaEntertainment
				},
				{
					path: '/africa/science',
					component: AfricaScience
				},
				{
					path: '/africa/technology',
					component: AfricaTechnology
				}
			],
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Africa')
				next()
			}
		},
		{
			path: '/auth',
			name: 'auth',
			component: Auth,
			beforeEnter(to, from, next) {
				if (vxStore.state.user.authUser) {
					next({
						path: from.path
					})

					return;
				}

				vxStore.commit('updateAppSubtitle', 'NG')
				next()
			}
		},
		{
			path: '/profile/:username',
			components: {
				authView: Profile
			},
			beforeEnter: (to, from, next) => {
				vxStore.commit('updateAppSubtitle', 'NG')

				if (!vxStore.state.user.authUser || !to.params) {
					console.log('user not authenticated')
					next({
						path: '/auth'
					})
				} else {
					next()
				}
			}
		},
		{
			name: 'UserView',
			path: '/s/:username',
			components: {
				authView: UserView
			},
			beforeEnter: (to, from, next) => {
				vxStore.commit('updateAppSubtitle', 'NG')
				next()
			}
		},
		{
			path: '/art',
			component: Art,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Art')
				next()
			}
		},
		{
			path: '/agriculture',
			component: Agriculture,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Agriculture')
				next()
			}
		},
		{
			path: '/cuisine',
			component: Cuisine,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Cuisine')
				next()
			}
		},
		{
			path: '/culture',
			component: Culture,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Culture')
				next()
			}
		},
		{
			path: '/economy',
			component: Economy,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Economy')
				next()
			}
		},
		{
			path: '/education',
			component: Education,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Education')
				next()
			}
		},
		{
			path: '/environment',
			component: Environment,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Environment')
				next()
			}
		},
		{
			path: '/family',
			component: Family,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Family')
				next()
			}
		},
		{
			path: '/fitness',
			component: Fitness,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Fitness')
				next()
			}
		},
		{
			path: '/politics',
			component: Politics,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Politics')
				next()
			}
		},
		{
			path: '/feminism',
			component: Feminism,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Feminism')
				next()
			}
		},
		{
			path: '/bokoharam',
			component: BokoHaram,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Boko Haram')
				next()
			}
		},
		{
			path: '/covid-19',
			component: CoronaVirus,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Covid-19')
				next()
			}
		},
		// {
		// 	path: '/election',
		// 	component: Election,
		// 	beforeEnter(to, from, next) {
		// 		vxStore.commit('updateAppSubtitle', 'Election')
		// 		next()
		// 	}
		// },
		{
			path: '/corruption',
			component: Corruption,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Corruption')
				next()
			}
		},
		{
			path: '/spotlight/:nickname',
			component: Person,
			props: true,
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', to.params.nickname)
				next()
			}
		},
		{
			name: 'story',
			path: '/story/',
			component: Story,
			props: (route) => ({
				...route.params
			}),
			beforeEnter(to, from, next) {
				vxStore.commit('updateAppSubtitle', 'Story')
				next()
			}
		},
		{
			name: 'source',
			path: '/sources/:sourceId',
			component: Source,
			props: (route) => ({
				...route.params
			}),
			beforeEnter: (to, from, next) => {
				vxStore.commit('updateAppSubtitle', to.params.sourceName)
				next()
			}
		},
		{
			path: "*",
			component: PageNotFound,
			beforeEnter: (to, from, next) => {
				vxStore.commit('updateAppSubtitle', 'NG')
				next()
			}
		}
	],
	scrollBehavior(to, from, savedPosition) {
		let position = {
			x: 0,
			y: 0
		}
		if (savedPosition) {
			position = savedPosition
		}

		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve(position)
			}, 500)
		})
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js